<template>
  <div>
    Página não encontrada.
  </div>
</template>
